import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { ElementType } from "../dom-tools/ElementType";
import { Insight } from "../dom-tools/Insight";

export class VideoAutoPlayOnInsight
{
  static readonly attribute = new ElementAttribute( "autoplay-on-insight" );

  static applyOnDocument( insight:Insight )
  {
    VideoAutoPlayOnInsight.attribute.forEachInDoc( 
      e => VideoAutoPlayOnInsight.applyOnElement( e as HTMLVideoElement, insight ) 
    );
  }

  static applyOnElement( v:HTMLVideoElement, insight:Insight )
  {
    insight.onInsight( 
      v, 
      () => 
      { 
        ElementAttribute.autoplay.to( v );
        v.play();
      }
    );

    insight.onOffsight( 
      v, 
      () => 
      { 
        ElementAttribute.autoplay.from( v );
        v.pause();
      }
    );
  }
}
